export let JobStatus = /*#__PURE__*/function (JobStatus) {
  JobStatus["PENDING"] = "pending";
  JobStatus["RESOLVED"] = "resolved";
  JobStatus["REJECTED"] = "rejected";
  return JobStatus;
}({});